/**
 * angular imports
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
/**
 * prime ng imports
 */
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
/**
 * pipes module
 */
import { PipesModule } from 'src/app/pipes/pipes.module';


/**
 * module for autocomplete element
 */

@NgModule({
  declarations: [
    AutocompleteComponent
  ],
  imports: [
    CommonModule,
    AutoCompleteModule,
    FormsModule, 
    ReactiveFormsModule,
    PipesModule
  ],
  exports: [
    AutocompleteComponent
  ]
})
export class AutocompleteModule { }
